import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroSection from './components/HeroSection';
import FeaturedSection from './components/FeaturedSection';
import CategorySection from './components/CategorySection';
import LatestSection from './components/LatestSection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

export default function Home() {
  const websiteLd = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '韩漫画网',
    url: 'https://www.hanmanhua.com',
    description: '韩漫画网精选好看的韩国漫画供您韩漫在线免费阅读，同时提供高清韩漫大全，画质清晰带来视觉上的享受',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://www.hanmanhua.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(websiteLd)}</script>
      <ScrollToTop />
      <Navbar />
      <main>
        <HeroSection />
        <FeaturedSection />
        <CategorySection />
        <LatestSection />
        <CTASection />
        <FAQSection />
      </main>
      <Footer />
    </>
  );
}